export default class Accordion {
	constructor(element) {
		this.trigger = element.querySelector('.js-accordion-trigger');
		this.content = element.querySelector('.accordion__content');
		this.init();
	}

	init() {
		this.trigger.addEventListener('click', this.handleClick);
	}

	handleClick = () => {
		const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
		const focusableElements = this.content.querySelectorAll('p > a');
		this.trigger.setAttribute('aria-expanded', !isOpen);

		focusableElements.forEach((el) => {
			if (isOpen) {
				el.setAttribute('tabindex', '-1'); // Remove from tab order
			} else {
				el.removeAttribute('tabindex'); // Restore tab order
			}
		});
	};
}
